import React, { useMemo, useState } from "react";
import { Button, Checkbox, Chip, ListItemText, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { outlinedButtonSx } from "../uiStyles";

export default function ChoiceButton({ label, value, options = [], onChange, multiple = false, disabled = false, error = false, required = false, placeholder, fullWidth = true, resetLabel = "" }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const display = useMemo(() => {
    if (multiple) {
      const labels = options.filter((item) => (value || []).includes(item.value)).map((item) => item.label);
      return labels.length ? labels.join(", ") : placeholder;
    }
    return options.find((item) => item.value === value)?.label || placeholder;
  }, [multiple, options, placeholder, value]);
  const choose = (next) => {
    if (!multiple) { onChange?.(next); setAnchorEl(null); return; }
    const current = value || [];
    onChange?.(current.includes(next) ? current.filter((item) => item !== next) : [...current, next]);
  };
  return <>
    <Button disabled={disabled} variant="outlined" onClick={(event) => setAnchorEl(event.currentTarget)} endIcon={<KeyboardArrowDownRoundedIcon />} sx={{ ...outlinedButtonSx, width: fullWidth ? "100%" : "auto", minHeight: 40, justifyContent: "space-between", color: "text.primary", bgcolor: "background.paper", overflow: "hidden", fontWeight: 400, "& .MuiButton-endIcon": { flexShrink: 0 }, ...(error ? { borderColor: "error.main", color: "error.main", "&:hover": { borderColor: "error.main" } } : {}) }}>
      <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {label}
        {required && <span aria-hidden="true"> *</span>}
        {display ? `: ${display}` : ""}
      </span>
    </Button>
    <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)} PaperProps={{ sx: { mt: 0.75, minWidth: anchorEl?.clientWidth || 220, maxWidth: 360 } }}>
      {options.map((item) => {
        const checked = multiple ? (value || []).includes(item.value) : value === item.value;
        return <MenuItem key={String(item.value)} selected={checked} onClick={() => choose(item.value)} sx={{ mx: 0 }}>
          {multiple && <Checkbox checked={checked} size="small" sx={{ p: 0, mr: 1 }} />}
          <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: 14 }} />
          {item.hint && <Chip size="small" variant="outlined" label={item.hint} sx={{ ml: 1.5, height: 22, fontSize: 12, color: "text.secondary" }} />}
        </MenuItem>;
      })}
      {multiple && resetLabel && (
        <Button
          fullWidth
          disabled={!(value || []).length}
          onClick={() => { onChange?.([]); setAnchorEl(null); }}
          sx={{ mt: 0.5, fontWeight: 400, color: "text.secondary" }}
        >
          {resetLabel}
        </Button>
      )}
    </Menu>
  </>;
}
